import React, { useEffect, useState } from "react";
import { MessageSquare, Settings, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  id: 1,
  title: "Share the Love",
  description: "Tell everyone you know about Website Shop; and how awesome your website is!",
  icon: MessageSquare,
  label: "STEP 01"
}, {
  id: 2,
  title: "They Sign Up",
  description: "Your friends use your name to and join our growing community of small businesses.",
  icon: Settings,
  label: "STEP 02"
}, {
  id: 3,
  title: "Get Rewarded",
  description: "Receive a $100 VISA gift card, spendable anywhere that accepts VISA cards!",
  icon: TrendingUp,
  label: "STEP 03"
}];
export default function HowItWorks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const [lineHeight, setLineHeight] = useState(0);
  const lineClass = isVisible ? "w-full" : "w-0";
  return <section data-section-id="48488" id="how-it-works" ref={ref} className="bg-background py-24 relative overflow-hidden text-foreground">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-20">
          <h2 className="text-4xl md:text-5xl font-extrabold text-foreground mb-4 tracking-tight">
            Our Referral Process
          </h2>
          <p className="text-muted-foreground text-xl">
            A simple three-step process designed to help you share value and get rewarded for growing our community.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {}
          <div className="absolute top-1/2 left-0 w-full -translate-y-1/2 h-24 pointer-events-none z-0">
             <svg className="w-full h-full" viewBox="0 0 1000 100" preserveAspectRatio="none">
              <style>{`
                @keyframes glowMove {
                  0% { stroke-dashoffset: 0; }
                  100% { stroke-dashoffset: -800; }
                }
              `}</style>
              <path d="M 100 50 C 300 50, 300 50, 500 50 C 700 50, 700 50, 900 50" fill="none" stroke="var(--color-primary)" strokeWidth="2" strokeDasharray="10 10" className="opacity-20" />
              <path d="M 100 50 C 300 50, 300 50, 500 50 C 700 50, 700 50, 900 50" fill="none" stroke="var(--color-primary)" strokeWidth="3" strokeLinecap="round" className={`transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
              strokeDasharray: "80 720",
              animation: isVisible ? "glowMove 3s linear infinite" : "none",
              filter: "drop-shadow(0 0 8px var(--color-primary))"
            }} />
            </svg>
          </div>

          {steps.map((step, i) => <div key={step.id} data-index={i} className="relative group">
              {}
              <div className="absolute -top-16 -left-4 md:-left-8 text-[120px] font-extrabold leading-none select-none pointer-events-none z-0 transition-transform duration-700 ease-out" style={{
            color: "transparent",
            WebkitTextStroke: "2px var(--color-primary)",
            opacity: 0.05,
            transform: isVisible ? "translateY(0)" : "translateY(20px)"
          }}>
                {step.id}
              </div>

              {}
              <Card className={`
                  relative z-10 h-full border-white/10 shadow-lg bg-[#1a1a1c]
                  rounded-[24px] transition-all duration-300 hover:-translate-y-2 hover:border-primary
                  ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
                `} style={{
            transitionDelay: `${i * 200}ms`
          }}>
                <CardHeader className="pb-4">
                  <div className="flex items-center justify-between mb-4">
                    <span className="font-mono text-xs font-bold text-primary tracking-widest bg-primary/10 px-3 py-1 rounded-full">
                      {step.label}
                    </span>
                    <step.icon className="w-8 h-8 text-primary stroke-[1.5]" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-white">
                    {step.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed text-gray-400">
                    {step.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}